export const sine = {
  in: [0.47, 0, 0.745, 0.715],
  out: [0.39, 0.575, 0.565, 1],
  inOut: [0.445, 0.05, 0.55, 0.95]
};
